module.exports = require("./qu-BO.d.ts");